import { Link, type LinkProps } from 'react-router-dom';
import { getButtonClasses } from './button.styles';
import type { BaseButtonProps } from './button.types';
import { forwardRef } from 'react';

interface UIButtonLinkProps extends Omit<LinkProps, 'className'>, BaseButtonProps {
  children: React.ReactNode;
}

export const UIButtonLink = forwardRef<HTMLAnchorElement, UIButtonLinkProps>(
  ({ size = 'medium', variant = 'primary', shape = 'round', disabled = false, className, children, ...props }, ref) => {
    return (
      <Link ref={ref} className={getButtonClasses(size, variant, shape, disabled, className)} {...props}>
        {children}
      </Link>
    );
  }
);
